import React from 'react';
import { HTMLTemplate } from '@/lib/templates/htmlTemplates';
import TemplatePreview from './TemplatePreview';

interface TemplateSelectorProps {
  templates: HTMLTemplate[];
  selectedTemplate: string;
  onTemplateSelect: (templateId: string) => void;
  className?: string;
}

const TemplateSelector: React.FC<TemplateSelectorProps> = ({
  templates,
  selectedTemplate,
  onTemplateSelect,
  className = ''
}) => {
  return (
    <div className={`template-selector ${className}`}>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {templates.map((template) => (
          <div
            key={template.id}
            className={`template-option cursor-pointer rounded-lg border-2 p-3 transition-all hover:shadow-md ${
              selectedTemplate === template.id
                ? 'border-xiaohongshu-red bg-xiaohongshu-red/5'
                : 'border-gray-200 hover:border-gray-300'
            }`}
            onClick={() => onTemplateSelect(template.id)}
          >
            <div className="preview-wrapper flex justify-center mb-3">
              <div
                className="preview-frame border border-gray-200 rounded-lg overflow-hidden bg-white shadow-sm"
                style={{ width: '100px', height: '150px' }}
              >
                <TemplatePreview
                  template={template}
                  className="w-full h-full"
                />
              </div>
            </div>
            <div className="text-center">
              <h3 className={`font-medium text-sm ${
                selectedTemplate === template.id 
                  ? 'text-xiaohongshu-red' 
                  : 'text-gray-700'
              }`}>
                {template.name}
              </h3>
              {selectedTemplate === template.id && (
                <div className="mt-1">
                  <span className="inline-block w-2 h-2 bg-xiaohongshu-red rounded-full"></span>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TemplateSelector;
